import BaseDealerSelect from "@/vendor/Dealer/BaseDealerSelect.js";

class QuotationDealerSelect extends BaseDealerSelect {

	addEventListeners() {
		super.addEventListeners();

		this.$scope.on('change', 'input[name="dealer"]', (e) => {
			e.preventDefault();
			let id = $(e.currentTarget).closest(this.config.list).find('input[name="dealer"]:checked').val();
			this.setDealer(id);
		})
	}

	showUI() {
		this.$scope.find(this.config.input).slideUp();
		this.$scope.find(this.config.choices).slideDown({complete: () => this.map.zoom()});
	}

	close() {
		this.$scope.find(this.config.choices).slideUp();
		this.$scope.find(this.config.input).slideDown();
	}
}

export default new QuotationDealerSelect({
	scope: '[data-quotation="scope"]',
	list: '[data-find-dealer="list"]',
	id: '[data-find-dealer="id"]',
	selectByMap: '[data-dealer-select]',
	selectByList: '[data-find-dealer="select-by-list"]',
	input: '[data-find-dealer="select-input"]',
	open: '[data-find-dealer="open"]',
	close: '[data-find-dealer="close"]',
	choices: '[data-find-dealer="choices"]',
	addressFields: [
		'[name="zipcode"]',
		'[name="street"]',
		'[name="street_number"]',
		'[name="town"]',
	],
	addressMap: {
		zipcode: "zipcode",
		street: "street",
		street_number: "street_number",
		street_number_extra: "street_number_extra",
		town: "town",
	}
});
